const CTA_TEXT = {
    autoship: { add: 'Add to Autoship', added: 'Added to Autoship' },
    cart: { add: 'Add to cart', added: 'Added to cart' },
} as const;

type GetCtaText = {
    isAutoshipText: boolean;
};

export const getCtaText = ({ isAutoshipText }: GetCtaText) => {
    if (isAutoshipText) return CTA_TEXT['autoship'];
    return CTA_TEXT['cart'];
};
